const create = (base) => ({
  base,
  detail: `${base}/:id(\\d+)`,
  trash: `${base}/trash`
})
const createWithTrash = (base) => ({
  ...create(base),
  trash: `${base}/trash`
})

const LOOKUPS_ROOT = '/lookups'
const ORDERS_ROOT = '/orders'

export const urls = {
  dashboard: { base: '' },
  winesInStock: { base: '/winesInStock' },
  login: { base: '/login' },
  logout: { base: '/logout' },
  orderList: createWithTrash(`${ORDERS_ROOT}/list`),
  orderProcessing: createWithTrash(`${ORDERS_ROOT}/processing`),
  bottles: createWithTrash('/bottles'),
  bottlesSimple: createWithTrash('/bottlesSimple'),
  grapes: create(`${LOOKUPS_ROOT}/grapes`),
  producers: create(`${LOOKUPS_ROOT}/producers`),
  currencies: create(`${LOOKUPS_ROOT}/currencies`),
  wineStyles: create(`${LOOKUPS_ROOT}/wineStyles`),
  evaluators: create(`${LOOKUPS_ROOT}/evaluators`),
  wineTypes: create(`${LOOKUPS_ROOT}/wineTypes`),
  classificationByOrigins: create(`${LOOKUPS_ROOT}/classificationByOrigins`),
  classificationByParamses: create(`${LOOKUPS_ROOT}/classificationByParamses`),
  flavourCharacteristicses: create(`${LOOKUPS_ROOT}/flavourCharacteristicses`),
  storagePlaces: create(`${LOOKUPS_ROOT}/storagePlaces`),
  regions: create(`${LOOKUPS_ROOT}/regions`),
  countries: create(`${LOOKUPS_ROOT}/countries`),
  districts: create(`${LOOKUPS_ROOT}/districts`),
  subdistricts: create(`${LOOKUPS_ROOT}/subdistricts`),
  wines: create(`${LOOKUPS_ROOT}/wines`),
  suppliers: create(`${LOOKUPS_ROOT}/suppliers`),
  produceStyles: create(`${LOOKUPS_ROOT}/produceStyles`),
  vineyardStyles: create(`${LOOKUPS_ROOT}/vineyardStyles`),

  releaseNotes: { base: '/release-notes' },
  lookups: { base: LOOKUPS_ROOT },
  orders: { base: ORDERS_ROOT }
}
